// extracted by mini-css-extract-plugin
export default {"goBack":"goback_goBack__1Xtjp"};